export const UNITS_OPTIONS = [
  {
    label: "SF",
    value: "SF",
  },
  {
    label: "LF",
    value: "LF",
  },
  {
    label: "EA",
    value: "EA",
  },
  {
    label: "HR",
    value: "HR",
  },
  {
    label: "SQ",
    value: "SQ",
  },
  {
    label: "DA",
    value: "DA",
  },
  {
    label: "GL",
    value: "GL",
  },
  {
    label: "WK",
    value: "WK",
  },
  {
    label: "CF",
    value: "CF",
  },
  {
    label: "MO",
    value: "MO",
  },
];

export const ACTIVITY_OPTIONS = [
  {
    label: "- (Remove)",
    value: "-",
  },
  {
    label: "+ (Replace)",
    value: "+",
  },
  {
    label: "& (Remove and Replace)",
    value: "&",
  },
  {
    label: "M (Material Only)",
    value: "M",
  },
  {
    label: "I (Install only)",
    value: "I",
  },
  {
    label: "R (Detach and Reset)",
    value: "R",
  },
];
